// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import Option from '@deere/cps-it.warranty-model-factory/lib/option';
import OptionItem from './option-item';

const OptionCodesList = props =>
    <div>
        {props.options.map((option, index) =>
            <OptionItem
                canAddDeleteOption={props.canAddDeleteOption}
                key={index}
                onDelete={props.onDelete}
                option={option}
            />
        )}
    </div>;

OptionCodesList.displayName = 'OptionCodesList';
OptionCodesList.propTypes = {
    canAddDeleteOption: PropTypes.bool.isRequired,
    onDelete: PropTypes.func.isRequired,
    options: PropTypes.arrayOf(PropTypes.instanceOf(Option)).isRequired
};

export default OptionCodesList;



// WEBPACK FOOTER //
// ./src/product/details/components/option-codes-list.js